module.exports = __webpack_public_path__ + "static/media/badge.352c987b.svg";